import { Box, Skeleton, Typography } from '@mui/material';
import styled from '@mui/system/styled';

export const StyPaper = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.primary.background,
    padding: '12px',
    marginTop: '24px',
}));

export const StyBlock = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    height: '100%',
}));

export const StyLoadingSkeleton = styled(Skeleton)(() => ({
    flex: 1,
    height: '3em',
}));

export const StyCenterdTypography = styled(Typography)(() => ({
    display: 'flex',
    alignItems: 'center',
}));
